<div class="d-flex justify-content-end align-items-center mb-2">
  <button type="button" class="btn btn-primary" (click)="add()">
    <i class="fa-solid fa-plus me-2"></i>
    <span>{{ 'ADD' | translate }}</span>
  </button>
</div>

@if (loading) {
  <div class="text-center py-4">
    <i class="fa fa-spinner fa-spin fa-lg"></i>
  </div>
} @else {
  @if (configs.length > 0) {
    <table class="table table-striped">
      <thead>
        <tr>
          <th>{{ 'NAME' | translate }}</th>
          <th>{{ 'FORMAT' | translate }}</th>
          <th>{{ 'QUALIFIER' | translate }}</th>
          <th>{{ 'REDIRECT_URL' | translate }}</th>
          @if (usersAvailable) {
            <th class="text-center">{{ 'USERS' | translate }}</th>
          }
          <th class="text-end">{{ 'ACTIONS' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (config of configs; track config.id) {
          <tr>
            <td>{{ config.name }}</td>
            <td>{{ config.format | uppercase }}</td>
            <td>{{ config.qualifier }}</td>
            <td>
              <code>{{ config.redirectUrl }}</code>
            </td>
            @if (usersAvailable) {
              <td class="text-center">
                <span
                  class="badge"
                  [class.bg-secondary]="connectedCount(config) > 0"
                  [class.bg-light]="connectedCount(config) === 0"
                  [class.text-muted]="connectedCount(config) === 0"
                >
                  {{ connectedCount(config) }}
                </span>
              </td>
            }
            <td class="text-end">
              <button type="button" class="btn btn-sm btn-outline-secondary me-2" (click)="edit(config)">
                <i class="fa-solid fa-pen-to-square me-1"></i>
                <span>{{ 'EDIT' | translate }}</span>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary me-2"
                [title]="'PUNCHOUT_COPY_CONFIG_HELP' | translate"
                (click)="copy(config)"
              >
                <i class="fa-solid fa-copy me-1"></i>
                <span>{{ 'COPY' | translate }}</span>
              </button>
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="delete(config)">
                <i class="fa-solid fa-trash me-1"></i>
                <span>{{ 'DELETE' | translate }}</span>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <div class="text-center text-muted py-4">
      <span>{{ 'PUNCHOUT_NO_CONFIGS' | translate }}</span>
    </div>
  }

  <!--
    Punchout users no row above accounts for: a stored config id pointing at a deleted config, or a
    PUNCHOUT-role user with no config id at all. Sits outside the configs check on purpose, since
    deleting every config is exactly when this matters most.
  -->
  @if (usersAvailable && unconnectedUsers.length > 0) {
    <div class="small text-muted mt-2">
      <button
        type="button"
        class="btn btn-link btn-sm p-0 text-muted"
        (click)="unconnectedExpanded = !unconnectedExpanded"
      >
        <i
          class="fa-solid"
          [class.fa-chevron-right]="!unconnectedExpanded"
          [class.fa-chevron-down]="unconnectedExpanded"
        ></i>
        <span class="ms-1">{{ 'PUNCHOUT_UNCONNECTED_USERS' | translate }} ({{ unconnectedUsers.length }})</span>
      </button>
      @if (unconnectedExpanded) {
        <ul class="list-unstyled mb-0 mt-1 ms-3">
          @for (user of unconnectedUsers; track user.username) {
            <li>
              <a [routerLink]="['/admin/users-details', user.username]">{{ user.username }}</a>
            </li>
          }
        </ul>
      }
    </div>
  }
}
